import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

const usageReport: ThemeApp['appComponents']['usageReport'] = {
  sectionTitle: {
    color: themeUi.semantic.color.text.neutral800,
    spanColor: themeUi.semantic.color.text.neutral700,
    beforeColor: themeUi.semantic.color.text.neutral800
  },
  label: {
    color: themeUi.semantic.color.text.neutral800
  }
};

export default usageReport;
